import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import { useAppDispatch } from '../../../../hooks/redux';
import { ModalVariants } from '../../../../models/Common';
import { TextButton, TextButtonClassNames } from '../../../commons/buttons/TextButton';
import { modalSlice } from '../../../../store/reducers/ModalSlice';
import { PlusIcon } from '../../../commons/icons/PlusIcon';

interface IAdminTopBar {
  value: string;
  setValue: (s: React.SetStateAction<string>) => void;
}

export const AdminTopBar: FC<IAdminTopBar> = ({ value, setValue }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;

  const handleAddAccount = () => {
    dispatch(openModal({ modalVariants: ModalVariants.LinkAccount }));
  };

  return (
    <div className="multi-account__admin__actions">
      <div className="multi-account__admin__search">
        <TextField
          type="text"
          label={t('multiAccount.search')}
          className="input input__text-field__primary"
          onChange={(e) => setValue(e.target.value)}
          value={value}
          InputProps={{ autoComplete: 'off', inputProps: { maxLength: 150 } }}
        />
      </div>
      <div className="multi-account__admin__add-account">
        <TextButton
          label={t('multiAccount.addAccount')}
          handleClick={handleAddAccount}
          className={TextButtonClassNames.PrimaryActive}
          beforeIcon={<PlusIcon className="icon-add" />}
          isBold
        />
      </div>
    </div>
  );
};
